import React from 'react';
import { SlTooltip } from '@shoelace-style/shoelace/dist/react';

const ActionButton = ({ 
    icon, 
    alt, 
    tooltip, 
    onClick, 
    className = "w-5 h-5 cursor-pointer" 
}) => {
    return (
        <SlTooltip content={tooltip} hoist>
            <img
                src={icon}
                alt={alt}
                className={className}
                onClick={onClick}
            />
        </SlTooltip>
    );
};

export default ActionButton; 